import * as React from 'react';

function SvgShortTextIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#DB5461" />
      <g clipPath="url(#short-text-icon_svg__clip0)" fill="#232340">
        <path d="M17.248 18.964h-.355a.143.143 0 01-.135-.097L13.208 8.47a.854.854 0 00-.806-.579h-.004a.857.857 0 00-.81.58L8.05 18.867a.144.144 0 01-.135.097h-.343a.57.57 0 100 1.142H9.29a.57.57 0 00.572-.571.553.553 0 00-.473-.556.14.14 0 01-.097-.07.142.142 0 01-.011-.116l.875-2.574a.144.144 0 01.135-.097h4.217a.143.143 0 01.136.097l.879 2.575a.145.145 0 01-.051.162.144.144 0 01-.055.024.556.556 0 00-.462.555.57.57 0 00.571.572h1.72a.573.573 0 00.544-.794.571.571 0 00-.545-.349h.002zm-6.468-3.985a.143.143 0 01-.136-.19l1.62-4.756a.143.143 0 01.27 0l1.624 4.756a.144.144 0 01-.019.13.143.143 0 01-.117.058l-3.242.002z" />
        <path d="M20.428 18.964H20.3a.144.144 0 01-.135-.097L17.682 11.6a.892.892 0 00-1.692 0l-.67 1.974a.571.571 0 101.082.369l.3-.883a.143.143 0 01.27 0l.856 2.509a.143.143 0 01-.07.173.144.144 0 01-.065.016H16.9a.572.572 0 000 1.142h1.284a.144.144 0 01.135.097l.641 1.874a.143.143 0 01-.068.175.556.556 0 00-.26.713.572.572 0 00.528.353h1.27a.571.571 0 100-1.143v-.005z" />
      </g>
      <defs>
        <clipPath id="short-text-icon_svg__clip0">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgShortTextIcon;
